import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const STYLE_VARIANTS = {
  sm: "h-6 w-6",
  lg: "h-12 w-12",
};
export interface IconButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  id: string;
  ariaLabel: string;
  className?: string;
  showAlert?: boolean;
  active?: boolean;
  shouldRotate?: boolean;
  icon?: ReactNode;
  variant?: keyof typeof STYLE_VARIANTS;
  disabled?: boolean;
}

export const IconButton = ({
  onClick = () => {},
  className = "",
  id,
  ariaLabel,
  showAlert = false,
  active = false,
  shouldRotate = false,
  icon,
  variant = "lg",
  disabled = false,
}: IconButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        // Background
        active ? "bg-primary-500" : "bg-white/10",
        !disabled && "group-hover:bg-white/30 hover:bg-white/30",
        // Size
        STYLE_VARIANTS[variant],
        // Color
        active ? "text-secondary-950 dark:text-tertiary-950" : "text-white/80",
        !disabled && "hover:text-white",
        // Flexbox
        "flex items-center justify-center",
        // Other styles
        "relative cursor-pointer rounded-full",
        // Disabled styles
        disabled && "cursor-not-allowed",
        className
      )}
      data-testid={id}
      id={id}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {showAlert && (
        <div className="absolute top-1 right-2 flex h-2 w-2 items-center justify-center rounded-full bg-accent_two-500 md:top-2 md:right-3">
          <div className="h-2.5 w-2.5 animate-ping rounded-full bg-accent_two-500" />
        </div>
      )}
      {icon && (
        <span
          className={twMerge(
            "flex items-center justify-center",
            shouldRotate &&
              !disabled &&
              "transition-transform duration-150 ease-in-out group-hover:rotate-45 group-hover:text-primary-950 group-hover:dark:text-tertiary-950"
          )}
        >
          {icon}
        </span>
      )}
    </button>
  );
};
